import { DEGREE_PRODUCT_VARIANTS, ProductVariantNames } from 'bundles/browse/constants';
import {
  CONTENTFUL_DEGREE_RECS_CATEGORIES as degreeCategories,
  CONTENTFUL_DEGREE_RECS_PRODUCT_TYPES as productTypes,
} from 'bundles/unified-seo-content-common/constants';

type ValueOf<T> = T[keyof T];
type DegreeCategoryValue = ValueOf<typeof degreeCategories>;
type ProductVariantValue = ValueOf<typeof ProductVariantNames>;

const CATEGORY_MAP: Record<DegreeCategoryValue, string> = {
  [degreeCategories.Business]: 'BUSINESS',
  [degreeCategories.ComputerScience]: 'COMPUTER_SCIENCE',
  [degreeCategories.DataScience]: 'DATA_SCIENCE',
  [degreeCategories.DataAnalytics]: 'DATA_ANALYTICS',
  [degreeCategories.Management]: 'MANAGEMENT',
  [degreeCategories.PublicHealth]: 'HEALTHCARE',
  [degreeCategories.SocialSciences]: 'SOCIAL_SCIENCES',
  [degreeCategories.TopEuropean]: 'TOP_EUROPEAN',
  [degreeCategories.TopIndian]: 'TOP_INDIAN',
  [degreeCategories.TopLatam]: 'TOP_LATAM',
};

export const getFormattedCategoryString = (category: string | null): string | null => {
  if (!category) return null;
  // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  return category in CATEGORY_MAP ? CATEGORY_MAP[category] : null;
};

export const getFormattedCategoriesArray = (input: string | string[] | null): string[] | null => {
  if (!input) return null;
  if (Array.isArray(input)) {
    return input.map((val) => getFormattedCategoryString(val)).filter((val): val is string => Boolean(val));
  } else {
    const category = getFormattedCategoryString(input);
    return category ? [category] : null;
  }
};

export const getProductTypesArray = (input: string | null): ProductVariantValue[] => {
  if (!input) return DEGREE_PRODUCT_VARIANTS;
  switch (input) {
    case productTypes.Bachelors:
      return [ProductVariantNames.BachelorsDegree];
    case productTypes.Masters:
      return [ProductVariantNames.MastersDegree];
    default:
      return DEGREE_PRODUCT_VARIANTS;
  }
};
